import componentStyles from './betRecommendation.module.css'
import React, { useState } from 'react';
import HeatCheck from '../global/heatCheck';
import OurPicksSummary from './ourPicksSummary';
import { FaCircleMinus, FaCirclePlus } from 'react-icons/fa6';

const BetRecommendation = ({betRecommendation}) => {

    const [showMoneyLineInfo, setShowMoneyLineInfo] = useState(false);
    const [showSpreadInfo, setShowSpreadInfo] = useState(false);
    const [showTotalsInfo, setShowTotalsInfo] = useState(false);
    const [showPropBetsInfo, setShowPropBetsInfo] = useState(false);

    // Helper function to convert paragraph to bullet points
    const convertToBulletPoints = (text) => {
        if (!text) return [];
        
        // Split by common sentence endings and filter out empty strings
        const sentences = text.split(/[.!?]+/).filter(sentence => sentence.trim().length > 0);
        
        return sentences.map((sentence, index) => sentence.trim());
    };

    if (typeof betRecommendation === 'string') {
        return (
            <textarea className={componentStyles.inDepthBetCardScoutingReportTextarea} disabled={true}>{betRecommendation}</textarea>
        )
    } else if (typeof betRecommendation === 'object') {
        // Get betCardData from parent component (passed through ScoutingReport)
        const betCardData = betRecommendation._betCardData || null;
        return (
            <div className={componentStyles.betRecommendationContainer}>
                {/* Our Picks Summary Section */}
                <OurPicksSummary betRecommendation={betRecommendation} betCardData={betCardData} />
                {/* {!!betRecommendation['propBets'] && (
                                <div>
                                    <p>Prop Bets</p>
                                    {betRecommendation['propBets'].map((propBet, index) => (
                                        <div key={index}>
                                            <p>{propBet['propBet']}</p>
                                            <p>{propBet['propBetExplanation']}</p>
                                        </div>
                                    ))}
                                </div>
                            )}                             */}
            </div>
        )
    }
}

export default BetRecommendation;